$(document).ready(function () {
  
  function productFilter() {
    let ActiveBandFilterValue = [];
    let ActiveCupFilterValue = [];
    var CombinationArray = [];

    $(".collection-filters__filter-list-item").each(function () {
      let bandActive = $(this).hasClass("product_filter_band_active");
      if (bandActive) {
        let BandFilterValue = $(this).attr("data-value-band");
        ActiveBandFilterValue.push(BandFilterValue);
      }
    });

    $(".collection-filters__filter-list-item").each(function () {
      let cupActive = $(this).hasClass("product_filter_cup_active");
      if (cupActive) {
        let CupFilterValue = $(this).attr("data-value-cup");
        ActiveCupFilterValue.push(CupFilterValue);
      }
    });

    $(ActiveBandFilterValue).each(function (index, BandValue) {
      $(ActiveCupFilterValue).each(function (index, CupValue) {
        let CombinationVlaue = BandValue + CupValue;
        CombinationArray.push(CombinationVlaue);
      });
    });
    console.log(CombinationArray);
    console.log("ArrayLenght - " + CombinationArray.length);

    if (CombinationArray.length > 0) {
      $(".productgrid--item").css("display", "none");
      $('.grid-load-more.center').hide();
    } 
    else if (ActiveBandFilterValue.length > 0) {
      $(".productgrid--item").css("display", "none");
       $('.grid-load-more.center').hide();
    } 
    else if (ActiveCupFilterValue.length > 0) {
      $(".productgrid--item").css("display", "none");
       $('.grid-load-more.center').hide();
    }
    else {
      $(".productgrid--item").css("display", "block");
      LoadMorefunction();
    }

    // BRA-SIZE BNAD
     if (ActiveBandFilterValue.length > 0 && ActiveCupFilterValue.length == 0) {
      $.each(ActiveBandFilterValue, function (index, ArrayValue) {
        $(".card_product_varient_title").each(function () {
          let productVaientTitle_Band = $(this).attr("Varinet-Title");
          if (productVaientTitle_Band.indexOf(ArrayValue) >= 0) {
            console.log("BRA-SIZE BNAD");
            $(this).parents(".productgrid--item ").css("display", "block");
          }
        });
      });
     }

    // BRA-SIZE CUP
    else if (ActiveBandFilterValue.length == 0 && ActiveCupFilterValue.length > 0) {
      $.each(ActiveCupFilterValue, function (index, ArrayValue) {
        $(".card_product_varient_title").each(function () {
          let productVaientTitle_Cup = $(this).attr("Varinet-Title");
          if (productVaientTitle_Cup.indexOf(ArrayValue) >= 0) {
            console.log("BRA-SIZE CUP");
            $(this).parents(".productgrid--item ").css("display", "block");
          }
        });
      });
    }

    // BRA-SIZE COMBINATION
    else if (ActiveBandFilterValue.length > 0 && ActiveCupFilterValue.length  > 0) {
      $.each(CombinationArray, function (index, ArrayValue) {
        // console.log("ArrayValue - " + ArrayValue);
        $(".card_product_varient_title").each(function () {
          let productVaientTitle = $(this).attr("Varinet-Title");
          if (productVaientTitle.indexOf(ArrayValue) >= 0) {
            console.log("BRA-SIZE COMBINATION")
            $(this).parents(".productgrid--item ").css("display", "block");
          }
        });
      });
    }
  }
  productFilter();


    // LOAD MORE
    function LoadMorefunction() {
      $(".grid-load-more").show();
      $(".productgrid--items .productgrid--item").css("display", "none");
      $(".productgrid--items .productgrid--item").slice(0, 16).css("display", "block");
      $("#grid_laod_more_btn").on("click", function () {
      $(".productgrid--items .productgrid--item:hidden").slice(0, 16).slideDown("2500");
        if ($(".productgrid--items .productgrid--item:hidden").length == 0) {
          $(".grid-load-more").css("display", "none");
        }
      });
    }



  // COLLECTION-LIST
  var swiper = new Swiper(".collection-list__container_inner", {
    slidesPerView: 4,
    nextButton: ".arrow-left",
    prevButton: ".arrow-right",
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      1440: {
        slidesPerView: 4,
        spaceBetweenSlides: 30,
      },
      // when window width is <= 1440px
      1250: {
        slidesPerView: 3,
        spaceBetweenSlides: 30,
      },
      // when window width is <= 1250px
      750: {
        slidesPerView: 3,
        spaceBetweenSlides: 30,
      },
      // when window width is <= 750px
      0: {
        slidesPerView: 1,
        spaceBetweenSlides: 30,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  $(".bra_size_item , .category_band_grid_item").click(function () {
    $(this).css("background", "#ffd030");
    var bra_size_value = $(this).text();
    var Tag_display = $("#Tag_display").val();
    if (Tag_display == "") {
      var Tag_AddOn = bra_size_value;
    } else {
      if (Tag_display.includes(bra_size_value)) {
        var Tag_AddOn = Tag_display;
      } else {
        var Tag_AddOn = Tag_display + "," + bra_size_value;
      }
    }
    $("#Tag_display").val(Tag_AddOn);
    console.log($("#Tag_display").val());
  });

  $("#existing_customer").submit(function (e) {
    e.preventDefault();
    var form_data = new FormData();
    var existing_customer_val = $(
      ".existing_newsletter_email_input_second"
    ).val();
    var existing_customer_tag = $(".bra_tag_input").val();
    //alert(existing_customer_val + existing_customer_tag);

    form_data.append("email", existing_customer_val);
    form_data.append("oldtag", existing_customer_tag);
    $.ajax({
      type: "POST",
      url: "https://sizenotify.yourbrastore.com/project_file/yourbrastore/check_customer.php",
      data: form_data,
      contentType: false,
      cache: false,
      processData: false,
      success: function (response) {
        $(
          ".email_field_input_existing_customer , .pxs-newsletter-form-fields_head"
        ).hide();
        $(document).find("#res_data").text(response);
        $("#existing_customer")[0].reset();
        console.log(response);
      },
      error: function (err) {
        //alert('error');
      },
    });
  });

  // $(document).on('click','#existing_contactFormSubmit',function () {
  //   var existing_customer_val = $('.existing_newsletter_email_input_second').val();
  //   var existing_customer_tag = $('.bra_tag_input').val();
  //   alert(existing_customer_val + existing_customer_tag)
  // });

  // ReCapcha code with scrolling to that div
  $("#re-captcha").hide();
  $(".newsletter_email_input").click(function () {
    $("#re-captcha").show("3000");
  });

  var actCallback = function (response) {
    $("#contactFormSubmit").attr("disabled", false);
    $("#re-captcha").remove();
  };

  var expCallback = function () {
    $("#contactFormSubmit").attr("disabled", true);
  };

  var onloadCallback = function () {
    var widget = grecaptcha.render(document.getElementById("re-captcha"), {
      sitekey: "6Ld-5ccpAAAAAPQW8vfirW396w2Cz13jEe7TKs-P", // Sitekey, Retrieving from reCaptcha
      theme: "light",
      callback: actCallback,
      "expired-callback": expCallback,
    });
  };

  function scrollToDiv() {
    if (window.location.href.indexOf("#contact_form") > -1) {
      $("html, body").animate(
        {
          scrollTop: $("#itg_div_scroll").offset().top,
        },
        800
      );
      console.log("yes conditon is true");
    }
  }
  // Call the function on page load
  scrollToDiv();

  // Call the function when hash changes (e.g., when clicking on links)
  $(window).on("hashchange", scrollToDiv);

  // LOAD MORE
  // // $(".load-more").show();
  // $(".productgrid--items .productgrid--item").hide();
  // $(".productgrid--items .productgrid--item").slice(0, 8).show();
  //   $("#Laod_more_btn").on("click", function(){
  //   $(".productgrid--items .productgrid--item:hidden").slice(0, 8).slideDown('2500');
  // });
});
